export const APP_NAME_LONG = 'Knowledge Accelerator for Programming';
export const APP_NAME_SHORT = 'Unakite';
export const APP_WEBSITE = 'https://lxieyang.github.io/project-KAP/unakite/';

export const DEFAULT_SETTINGS = {
  shouldOverrideNewtab: false,
  shouldDisplayAllPages: false,
  shouldShowSelector: false,
  taskOngoing: true
};

export const showoffSurveyUrl =
  'https://oberlin.qualtrics.com/jfe/form/SV_eFqJnCBcw4AO0zb?Source=';

export const projectIntroPage =
  'https://lxieyang.github.io/project-KAP/unakite/';

// https://stackoverflow.com/questions/10282939/how-to-get-favicons-url-from-a-generic-webpage-in-javascript
export const GET_FAVICON_URL_PREFIX =
  'https://plus.google.com/_/favicon?domain_url=';
export const SNIPPET_TYPE = {
  SELECTION: 1,
  LASSO: 2,
  POST_SNAPSHOT: 3,
  PIECE_GROUP: 4,
  COPIED_PIECE: 5
};

export const cuteAnimalNames = [
  'alligator',
  'anteater',
  'armadillo',
  'auroch',
  'axolotl',
  'badger',
  'bat',
  'beaver',
  'buffalo',
  'camel',
  'chameleon',
  'cheetah',
  'chipmunk',
  'chinchilla',
  'chupacabra',
  'cormorant',
  'coyote',
  'crow',
  'dingo',
  'dinosaur',
  'dolphin',
  'duck',
  'elephant',
  'ferret',
  'fox',
  'frog',
  'giraffe',
  'gopher',
  'grizzly',
  'hedgehog',
  'hippo',
  'hyena',
  'jackal',
  'ibex',
  'ifrit',
  'iguana',
  'koala',
  'kraken',
  'lemur',
  'leopard',
  'liger',
  'llama',
  'manatee',
  'mink',
  'monkey',
  'narwhal',
  'nyan cat',
  'orangutan',
  'otter',
  'panda',
  'penguin',
  'platypus',
  'python',
  'pumpkin',
  'quagga',
  'rabbit',
  'raccoon',
  'rhino',
  'sheep',
  'shrew',
  'skunk',
  'slow loris',
  'squirrel',
  'turtle',
  'walrus',
  'wolf',
  'wolverine',
  'wombat'
];

export const backupCuteAnimalNames = 'alligator, anteater, armadillo, auroch, axolotl, badger, bat, beaver, buffalo, camel, chameleon, cheetah, chipmunk, chinchilla, chupacabra, cormorant, coyote, crow, dingo, dinosaur, dolphin, duck, elephant, ferret, fox, frog, giraffe, gopher, grizzly, hedgehog, hippo, hyena, jackal, ibex, ifrit, iguana, koala, kraken, lemur, leopard, liger, llama, manatee, mink, monkey, narwhal, nyan cat, orangutan, otter, panda, penguin, platypus, python, pumpkin, quagga, rabbit, raccoon, rhino, sheep, shrew, skunk, slow loris, squirrel, turtle, walrus, wolf, wolverine, wombat'
  .split(',')
  .map(ani => ani.trim());



// WEBPACK FOOTER //
// ../shared-components/src/shared/constants.js